import styled from 'styled-components';
import { COLORS, SIZE } from '@app/src/ui';

export const Wrapper = styled.div`
  height: 58px;
  display: flex;
  align-items: center;
`;

export const LogoWrapper = styled.a`
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 15px;
  margin-right: 6px;
  outline: none;
  img {
    width: auto;
    height: 100%;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    margin-right: 26px;
    height: 20px;

    svg{
      display: none;
    }
  }
`;

export const IconMainWrapper = styled.span`
  margin: 0 10px 0 0;
  cursor: pointer;
  display: inline-block;
  height: 20px;

  @media (min-width: 920px ) {
    margin: 0 30px 0 0;
    height: 24px;
    display: none;
    svg{
      width: 24px;
      height: 24px;
    }
  }
`;

export const IconCloseWrapper = styled.span`
  cursor: pointer;
  margin: 20px 28px;
  width: 20px;
  height: 20px;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  height: 58px;
  border-bottom: 1px solid ${COLORS.GRAY};
`;

const MAIN = 'Logo';
Wrapper.displayName = `${MAIN}/Wrapper`;
LogoWrapper.displayName = `${MAIN}/LogoWrapper`;
IconMainWrapper.displayName = `${MAIN}/IconMainWrapper`;
IconCloseWrapper.displayName = `${MAIN}/IconCloseWrapper`;
